import React from "react";
import IconButton from "@mui/material/IconButton";
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import ConnectWithoutContactOutlinedIcon from '@mui/icons-material/ConnectWithoutContactOutlined';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import contactLogo from "../../assets/images/images.jpg";
import useTranslation from '../../translations/use-translation';
import "./Contact.styles.scss";

const Contact = () => {
  const translate = useTranslation();

  return (
    <div className="contact-page">
      {/* Hero */}
      <section className="contact-hero">
        <div className="contact-hero__copy">
          <span className="contact-hero__eyebrow">GET IN TOUCH</span>
          <h1 className="contact-hero__title">{translate('MAIN_HEADING')}</h1>
          <p className="contact-hero__subtitle">{translate('SUB_HEADING')}</p>
        </div>
        <div className="contact-hero__image">
          <img src={contactLogo} alt="" />
        </div>
      </section>

      {/* Info cards */}
      <section className="contact-info-grid">
        <article className="contact-info-card contact-info-card--primary">
          <div className="contact-info-card__icon">
            <SupportAgentOutlinedIcon />
          </div>
          <h3 className="contact-info-card__title">{translate('ASSIST_HEADING')}</h3>
          <p className="contact-info-card__description">{translate('ASSIST_SUB_HEADING')}</p>
          <span className="contact-info-card__cta">
            <span>Talk to us</span>
            <ArrowOutwardIcon fontSize="small" />
          </span>
        </article>

        <article className="contact-info-card contact-info-card--info">
          <div className="contact-info-card__icon">
            <LocationOnOutlinedIcon />
          </div>
          <h3 className="contact-info-card__title">{translate('OFFICE_LOCATIONS')}</h3>
          <p className="contact-info-card__description">{translate('OFFICE_ADDRESS')}</p>
          <span className="contact-info-card__cta">
            <span>View on map</span>
            <ArrowOutwardIcon fontSize="small" />
          </span>
        </article>

        <article className="contact-info-card contact-info-card--success">
          <div className="contact-info-card__icon">
            <ConnectWithoutContactOutlinedIcon />
          </div>
          <h3 className="contact-info-card__title">{translate('FOLLOW_US')}</h3>
          <p className="contact-info-card__description">Stay up to date on new services and updates.</p>
          <div className="contact-info-card__socials">
            <IconButton aria-label="Facebook" className="contact-social-btn"><FacebookIcon fontSize="small" /></IconButton>
            <IconButton aria-label="Twitter" className="contact-social-btn"><TwitterIcon fontSize="small" /></IconButton>
            <IconButton aria-label="LinkedIn" className="contact-social-btn"><LinkedInIcon fontSize="small" /></IconButton>
          </div>
        </article>
      </section>
    </div>
  );
};

export default Contact;
